import { Component, Input, OnInit } from '@angular/core';
import { OperationalAssurancesTableSection } from 'src/app/model/shared/operational-assurance-table-section';

import { documentToHtmlString } from '../api-reference-table-section';

@Component({
  selector: 'app-operational-assurances-table-section',
  templateUrl: './operational-assurances-table-section.component.html',
  styleUrls: ['./operational-assurances-table-section.component.scss']
})
export class OperationalAssurancesTableSectionComponent {
  @Input() tableSections: OperationalAssurancesTableSection[] = [];
  constructor() {}

  returnHtmlFromRichText(richText: any): string {
    if (richText === undefined || richText === null || richText.nodeType !== 'document') {
      return '<p>Error</p>';
    }

    return documentToHtmlString(richText);
  }
}
